/**
 * useUserRitualTeachings Hook
 * Fetches rituals user created
 */

import { useQuery } from "@tanstack/react-query"
import { getUserRitualTeachings } from "../services/user-rituals.service"

interface UseUserRitualTeachingsOptions {
  page?: number
  limit?: number
  search?: string
  subTab?: string
  enabled?: boolean
}

export function useUserRitualTeachings(userId: string, options?: UseUserRitualTeachingsOptions) {
  return useQuery({
    queryKey: [
      "user-ritual-teachings",
      userId,
      options?.page,
      options?.limit,
      options?.search,
      options?.subTab,
    ],
    queryFn: async () => {
      const result = await getUserRitualTeachings(userId, {
        page: options?.page,
        limit: options?.limit,
        search: options?.search,
        subTab: options?.subTab,
      })
      return result
    },
    enabled: options?.enabled ?? !!userId,
    staleTime: 1000 * 30, // 30 seconds - reduced for fresher data
    refetchOnMount: true,
  })
}
